import { PipeObject, Token } from '../types';

type MustacheReplacement = {
  searchValue: string;
  replaceValue: string;
};

export const Mustache = () => {
  return ({ input, lex, data }: PipeObject) => {
    let obj: Token;
    // list of all mustaches
    let mustacheReplacements: MustacheReplacement[] = [];
    while ((obj = lex.next())) {
      let mustacheStart, mustacheEnd;
      // {{ mustache_start
      if (obj.token === 'mustache_start') {
        // keep moving forward until we find mustache_end
        mustacheStart = obj;
        while ((obj = lex.next())) {
          // }} mustache_end
          if (obj.token === 'mustache_end') {
            mustacheEnd = obj;
            // we have {{}}, get out and process
            break;
          }
        }

        // get the obj name inside of {{}}
        const mustacheValue = input.substring(
          mustacheStart.end + 1,
          mustacheEnd.begin
        );

        // replace value from data object
        let replacedMustacheValue =
          mustacheValue
            ?.trim()
            ?.split('.')
            ?.reduce((o, i) => o && o[i], data) || '';
        // construct the full mustache value
        const fullMustache = input.substring(
          mustacheStart.begin,
          mustacheEnd.end + 1
        );
        if (fullMustache) {
          mustacheReplacements.push({
            searchValue: fullMustache,
            replaceValue: replacedMustacheValue as string,
          });
        }
      }
    }

    // loop through each mustache value, and replace with data value
    for (const mr of mustacheReplacements) {
      input = input.replace(new RegExp(mr.searchValue, 'gi'), mr.replaceValue);
    }

    return { input, lex, data };
  };
};
